import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import {
  mockStatusOverview,
  mockActionItems,
  mockActiveOrders,
  mockMessages,
} from '@/mocks/dashboard';
import DashboardStatusCards from './components/DashboardStatusCards';
import DashboardActionBanner from './components/DashboardActionBanner';
import DashboardOrders from './components/DashboardOrders';
import DashboardMessages from './components/DashboardMessages';
import DashboardQuotes from './components/DashboardQuotes';

export default function DashboardPage() {
  const { t } = useTranslation('dashboard');
  const { user, profile, company } = useAuth();
  const displayName = company?.company_name || profile?.full_name || user?.email?.split('@')[0] || '';

  return (
    <div>
      {/* Welcome Header */}
      <div className="mb-6 md:mb-8">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">
          {t('dashboard.welcome', { name: displayName })}
        </h1>
        <p className="text-sm text-ink-300 mt-1">{t('dashboard.subtitle')}</p>
      </div>

      {/* Status Cards */}
      <div className="mb-6 md:mb-8">
        <DashboardStatusCards data={mockStatusOverview} />
      </div>

      {/* Action Required */}
      {mockActionItems.length > 0 && (
        <div className="mb-6 md:mb-8">
          <DashboardActionBanner items={mockActionItems} />
        </div>
      )}

      {/* Recent Quotes (live from API) */}
      <div className="mb-6 md:mb-8">
        <DashboardQuotes />
      </div>

      {/* Recent Orders & Messages */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        <DashboardOrders orders={mockActiveOrders.slice(0, 3)} />
        <DashboardMessages messages={mockMessages.slice(0, 3)} />
      </div>
    </div>
  );
}